export interface SlotSummary {
    booked: number;
    error: number;
    open: number;
    date: Date;
    isSpecialDay: boolean;
    isClosed: boolean;
    specialTimeAb: string;
    specialTimeBis: string;
}

export interface SlotDetail {
    SLOT_NR: string;
    SLOTVON_DATE: Date;
    SLOTBIS_DATE: Date;
    SLOTVON_TIME: string;
    SLOTBIS_TIME: string;
    SLOT_STATUS: SlotStatus;
    start: Date;
    end: Date;
    KFZ_KENNZEICHEN: string;
    PRODUCT: string;
    MATERIALS: string[];
    LIEFER_NR: string;
    // TODO more stuff here
}

export interface SpecialDate {
    SPECIAL_DATE: Date;
    BEMERKUNG: string;
    BEZEICHNUNG: string;
    GESCHLOSSEN_FLAG: boolean;
    OFFENAB_TIME: string;
    OFFENBIS_TIME: string;
}

export enum SlotStatus {
    OPEN = '0', BOOKED = '1', BLOCKED = '2', ERROR = '3'
}
